import { render, staticRenderFns } from "./VQueue.vue?vue&type=template&id=12706ed2&"
import script from "./VQueue.vue?vue&type=script&lang=js&"
export * from "./VQueue.vue?vue&type=script&lang=js&"
import style0 from "./VQueue.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports